// src/components/Navbar.js
import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import useAdmin from '../utile/useAdmin';

function Navbar() {
  const navigate = useNavigate();
  const isAdmin = useAdmin();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const styles = {
    navbar: {
      backgroundColor: '#1e293b',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      position: 'sticky',
      top: 0,
      zIndex: 50,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 16px'
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '64px'
    },
    brand: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    logo: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#ffffff',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    nav: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    navMobile: {
      display: 'none'
    },
    navLink: {
      color: '#cbd5e1',
      textDecoration: 'none',
      padding: '8px 16px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-in-out',
      whiteSpace: 'nowrap'
    },
    navLinkActive: {
      backgroundColor: '#059669',
      color: '#ffffff'
    },
    dropdown: {
      position: 'relative',
      display: 'inline-block'
    },
    dropdownButton: {
      color: '#cbd5e1',
      background: 'none',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      transition: 'all 0.2s ease-in-out'
    },
    dropdownContent: {
      position: 'absolute',
      top: '100%',
      left: 0,
      backgroundColor: '#ffffff',
      minWidth: '250px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      borderRadius: '8px',
      padding: '8px',
      marginTop: '4px',
      zIndex: 1000,
      border: '1px solid #e2e8f0'
    },
    dropdownItem: {
      display: 'block',
      color: '#374151',
      textDecoration: 'none',
      padding: '12px 16px',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'background-color 0.2s ease-in-out',
      whiteSpace: 'nowrap'
    },
    logoutButton: {
      backgroundColor: '#dc2626',
      color: '#ffffff',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out'
    },
    mobileMenuButton: {
      display: 'none',
      backgroundColor: 'transparent',
      border: 'none',
      color: '#ffffff',
      padding: '8px',
      borderRadius: '4px',
      cursor: 'pointer'
    },
    mobileMenu: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: '#1e293b',
      borderTop: '1px solid #334155',
      padding: '16px',
      display: isMobileMenuOpen ? 'block' : 'none'
    },
    mobileLinkGroup: {
      marginBottom: '16px'
    },
    mobileLinkGroupTitle: {
      color: '#94a3b8',
      fontSize: '12px',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      marginBottom: '8px',
      padding: '0 16px'
    },
    mobileLink: {
      display: 'block',
      color: '#cbd5e1',
      textDecoration: 'none',
      padding: '12px 16px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      marginBottom: '4px'
    }
  };

  // Responsive styles
  const mediaQuery = window.matchMedia('(max-width: 768px)');
  if (mediaQuery.matches) {
    styles.nav.display = 'none';
    styles.mobileMenuButton.display = 'block';
  }

  return (
    <nav style={styles.navbar}>
      <div style={styles.container}>
        <div style={styles.toolbar}>
          {/* Brand */}
          <div style={styles.brand}>
            <RouterLink to="/accueil" style={styles.logo}>
              Gestionnaire CHR
            </RouterLink>
          </div>

          {/* Desktop Navigation */}
          <div style={styles.nav}>
            <RouterLink
              to="/accueil"
              style={styles.navLink}
              onMouseEnter={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.backgroundColor = '#334155';
                  e.target.style.color = '#ffffff';
                }
              }}
              onMouseLeave={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#cbd5e1';
                }
              }}
            >
              Accueil
            </RouterLink>

            {isAdmin && <AdminDropdown styles={styles} />}

            <button
              onClick={handleLogout}
              style={styles.logoutButton}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#b91c1c';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#dc2626';
              }}
            >
              Déconnexion
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            style={styles.mobileMenuButton}
            onClick={toggleMobileMenu}
          >
            <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        <div style={styles.mobileMenu}>
          <div style={styles.mobileLinkGroup}>
            <RouterLink
              to="/accueil"
              style={styles.mobileLink}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Accueil
            </RouterLink>
          </div>

          {isAdmin && (
            <div style={styles.mobileLinkGroup}>
              <div style={styles.mobileLinkGroupTitle}>Administration</div>

              {/* Notifications push (admin only) */}
              {/* <RouterLink
                to="/admin/dashboard"
                style={styles.mobileLink}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                📊 Dashboard
              </RouterLink> */}

              <RouterLink
                to="/admin/dashboard2"
                style={styles.mobileLink}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                📈 Dashboard KPI
              </RouterLink>

              <RouterLink
                to="/admin/push"
                style={styles.mobileLink}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                🔔 Notifications push
              </RouterLink>

              <RouterLink
                to="/admin/manage-container-cards"
                style={styles.mobileLink}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Gérer les contenants
              </RouterLink>

              <RouterLink
                to="/admin/manage-products-shop"
                style={styles.mobileLink}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Gérer la boutique
              </RouterLink>

              <RouterLink
                to="/admin/create-categories/"
                style={styles.mobileLink}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Création des catégories
              </RouterLink>

              <RouterLink
                to="/admin/entreprise/"
                style={styles.mobileLink}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Entreprises
              </RouterLink>
            </div>
          )}

          <div style={styles.mobileLinkGroup}>
            <button
              onClick={handleLogout}
              style={{
                ...styles.mobileLink,
                backgroundColor: '#dc2626',
                color: '#ffffff',
                border: 'none',
                cursor: 'pointer',
                width: '100%',
                textAlign: 'left'
              }}
            >
              Déconnexion
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

function AdminDropdown({ styles }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      style={styles.dropdown}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        style={{
          ...styles.dropdownButton,
          backgroundColor: isOpen ? '#334155' : 'transparent',
          color: isOpen ? '#ffffff' : '#cbd5e1'
        }}
      >
        Administration
        <svg
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease-in-out'
          }}
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div style={styles.dropdownContent}>
          {/* Notifications push (admin only) */}
          {/* <RouterLink
            to="/admin/dashboard"
            style={styles.dropdownItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            📊 Dashboard
          </RouterLink> */}

          <RouterLink
            to="/admin/dashboard2"
            style={styles.dropdownItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            📈 Dashboard KPI
          </RouterLink>

          <RouterLink
            to="/admin/push"
            style={styles.dropdownItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            🔔 Notifications push
          </RouterLink>

          <RouterLink
            to="/admin/manage-container-cards"
            style={styles.dropdownItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            🥤 Gérer les contenants
          </RouterLink>

          <RouterLink
            to="/admin/manage-products-shop"
            style={styles.dropdownItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            🛍️ Gérer la boutique
          </RouterLink>

          <RouterLink
            to="/admin/entreprise/"
            style={styles.dropdownItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            🏢 Entreprises
          </RouterLink>
        </div>
      )}
    </div>
  );
}

export default Navbar;